(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["layout-header"]) return;
  try {
    
(function() {
  function updateAuthLink() {
    var isPortal = window.location.pathname.includes('/pages/portal');
    var btn = document.getElementById(isPortal ? 'portal-header-login-button' : 'header-login-button');
    if (!btn) return;
    var link = btn.querySelector('a');
    if (!link) return;

    fetch('/account.js', { credentials: 'include', redirect: 'manual' })
      .then(function(r) {
        var loggedIn = r.type !== 'opaqueredirect' && r.ok;
        if (isPortal) {
          if (loggedIn) {
            link.innerHTML = 'Log&nbsp;Out';
            link.setAttribute('aria-label', 'Log Out');
            link.setAttribute('href', '/account/logout');
          } else {
            link.innerHTML = 'Log&nbsp;In';
            link.setAttribute('aria-label', 'Log In');
            link.setAttribute('href', '/account');
          }
        } else {
          if (loggedIn) {
            link.innerHTML = 'Dashboard';
            link.setAttribute('aria-label', 'Dashboard');
          } else {
            link.innerHTML = 'Log&nbsp;In';
            link.setAttribute('aria-label', 'Log In');
          }
        }
      })
      .catch(function() {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAuthLink);
  } else {
    updateAuthLink();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-rokt-sticky-cta"] && !Shopify.designMode) return;
  try {
    
(function () {
  const ctaBars = document.querySelectorAll('[data-rokt-sticky-cta]');
  if (!ctaBars.length) return;

  function setup() {
    const builderCta = document.getElementById('builder-cta');
    if (!builderCta) return false;

    const headerHeight = window.innerWidth >= 1024 ? 88 : 74;

    new IntersectionObserver(
      ([entry]) => {
            const aboveViewport = !entry.isIntersecting && entry.boundingClientRect.top < headerHeight;
        ctaBars.forEach((bar) => bar.classList.toggle('translate-y-full', !aboveViewport));
        const visibleBar = Array.from(ctaBars).find((bar) => getComputedStyle(bar).display !== 'none');
        let spacer = document.getElementById('rokt-sticky-spacer');
        if (aboveViewport && visibleBar) {
          if (!spacer) {
            spacer = document.createElement('div');
            spacer.id = 'rokt-sticky-spacer';
            spacer.style.background = 'rgb(37, 35, 35)';
            document.body.appendChild(spacer);
          }
          spacer.style.height = `${visibleBar.offsetHeight}px`;
        } else if (spacer) {
          spacer.remove();
        }
      },
      { threshold: 0, rootMargin: `-${headerHeight}px 0px 0px 0px` }
    ).observe(builderCta);

    return true;
  }

  if (!setup()) {
    const mo = new MutationObserver(() => {
      if (setup()) mo.disconnect();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
